<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12" lg="8">
        <b-card :header="caption">
          <b-row>
            <b-col cols="5">
              <b-form-group label="Name">
                <b-form-input type="text" class="form-control" v-model="schedule.name" />
              </b-form-group>
            </b-col>
          </b-row>
          <template slot="footer">
            <b-btn size="sm" variant="primary" @click="save">Save</b-btn>
            <!-- <b-btn class="ml-1" size="sm" variant="danger" @click="del">Delete</b-btn> -->
          </template>
        </b-card>
        <b-card border-variant="primary" header-bg-variant="primary" header-text-variant="white" header="Calendar">
          <b-form-group>
            <b-input-group prepend="Default Routing">
              <b-select :options="routingOptions" v-model="schedule.defaultProfileId" @change="save()"></b-select>
            </b-input-group>
          </b-form-group>
          <vue-cal style="height: 800px" :twelve-hour="true" :show-all-day-events="false" :start-week-on-sunday="true" active-view="week" :selected-date="selectedDate" :events="events" :disable-views="disableViews" v-on:ready="viewChange" v-on:view-change="viewChange" />
        </b-card>
      </b-col>
      <b-col sm="12" lg="4">
        <b-card border-variant="primary" header-bg-variant="primary" header-text-variant="white" header="Numbers">
          <p v-if="voiceNumbers.length == 0" class="mb-0 text-center">No available numbers</p>
          <b-list-group>
            <b-list-group-item v-for="number in voiceNumbers" v-bind:key="number.id" :variant="number.active ? 'success' : 'secondary'">
              <b-row>
                <b-col cols="6">
                  <b-link @click="toggleNumber(number.id)" class="bland">
                    <i :class="number.active ? 'icon-ban' : 'icon-power'" class="mr-3"></i>
                  </b-link>{{ number.name }}
                </b-col>
                <b-col cols="6" class="text-right">
                  <phone-number v-model="number.number"></phone-number>
                </b-col>
              </b-row>
            </b-list-group-item>
          </b-list-group>
        </b-card>
        {{ schedule.defaultProfile }}
      </b-col>
    </b-row>
    <edit-events-modal></edit-events-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import VueCal from 'vue-cal'
import PhoneNumber from '@/components/text/PhoneNumber'
import EditEventsModal from './partials/EditEvents'

export default {
  name: 'schedule',
  components: { EditEventsModal, PhoneNumber, VueCal },
  computed: {
    ...mapGetters({
      account: 'global/account',
      numbers: 'account/numbers',
      schedules: 'account/schedules',
      routingProfiles: 'account/routingProfiles',
    }),
    events () {
      if (!this.schedule) return []

      const events = []
      if (this.schedule.defaultProfile) {
        const start = moment(this.schedule.defaultProfile.created).format('YYYY-MM-DD')
        const end = moment().add(1, 'year').format('YYYY-MM-DD')
        events.push({
          start,
          end,
          title: this.schedule.defaultProfile.name,
          content: '',
          allDay: true,
          class: 'background',
          background: true
        })
      }
      return events
      // return [
      //   {
      //     start: '2022-08-01',
      //     end: '2022-08-31',
      //     title: 'Default Schedule',
      //     content: '',
      //     allDay: true,
      //     class: 'background',
      //     background: true
      //   },
      //   {
      //     start: '2022-08-01 10:35',
      //     end: '2022-08-01 11:30',
      //     title: 'Doctor appointment',
      //     content: '<i class="icon material-icons">local_hospital</i>',
      //     class: 'health',
      //     split: 1 // Has to match the id of the split you have set (or integers if none).
      //   },
      //   {
      //     start: '2022-08-01 18:30',
      //     end: '2022-08-01 19:15',
      //     title: 'Dentist appointment',
      //     content: '<i class="icon material-icons">local_hospital</i>',
      //     class: 'health',
      //     split: 2
      //   },
      //   {
      //     start: '2022-08-02 18:30',
      //     end: '2022-08-02 20:30',
      //     title: 'Crossfit',
      //     content: '<i class="icon material-icons">fitness_center</i>',
      //     class: 'sport',
      //     split: 1
      //   }
      // ]
    },
    flattened () {
      const events = this.scheduleRoutingProfiles.reduce((list, event) => {
        const curDate = moment(event.startAtDate)
        const endDate = moment(event.endAtDate)
        do {
          let startTime = event.startTime
          let endTime = event.endTime
          if (curDate.isSame(moment(event.startAtDate)) && moment(startTime, 'HH:mm:ss').isBefore(moment(event.startAtTime, 'HH:mm:ss'))) {
            startTime = event.startAtTime
          }
          if (curDate.isSame(moment(event.endAtDate)) && moment(endTime, 'HH:mm:ss').isAfter(moment(event.endAtTime, 'HH:mm:ss'))) {
            endTime = event.endAtTime
          }
          const existingEntry = list.find(o => o.date == curDate.format('YYYY-MM-DD'))

          if (existingEntry) {
            const time = {
              startTime,
              endTime,
              profile: { id: event.profile.id, name: event.profile.name }
            }
            existingEntry.times.push(time)
          } else {
            const entry = {
              date: curDate.format('YYYY-MM-DD'),
              times: []
            }
            const time = {
              startTime,
              endTime,
              profile: { id: event.profile.id, name: event.profile.name }
            }
            entry.times.push(time)
            list.push(entry)
          }

          curDate.add(1, 'day')
        } while (curDate <= endDate)
        return list
      }, [])
      return events
    },
    attributes () {
      // const today = { key: 'today', dates: new Date() }

      const events = this.scheduleRoutingProfiles.map(event => {
        return {
          key: event.id,
          dates: {
            start: moment(`${event.startAtDate} ${event.startAtTime}`).toDate(),
            end: event.endAtDate ? moment(`${event.endAtDate} ${event.endAtTime}`).toDate() : null
          },
          customData: event
        }
      })

      // if (this.schedule.defaultProfile) {
      //   const defaultProfile = { key: 'default', dates: { start: moment('1970-01-01 00:00:00').toDate(), end: null }}
      //   events.push(defaultProfile)
      // }
      return events
    },
    routingOptions () {
      return this.routingProfiles.map(o => ({ text: o.name, value: o.id }))
    },
    voiceNumbers () {
      const id = this.$route.params.id
      return this.numbers.filter(o => o.provider.voice && (o.scheduleId == null || o.scheduleId == id)).map(o => ({
        active: o.scheduleId == id,
        ...o
      }))
    }
  },
  data () {
    return {
      caption: 'Schedule',
      disableViews: [ 'years', 'year' ],
      schedule: {
        id: null,
        name: null,
        numbers: [],
        defaultProfile: {
          name: null
        }
      },
      selectedDate: moment().format('YYYY-MM-DD'),
      scheduleRoutingProfiles: []
    }
  },
  methods: {
    explodeTimes (day, attributes) {
      if (!attributes) return []
      return []
      // const flattenedEvents = this.flatten(moment(day.date), attributes.filter(o => o.customData).map(o => o.customData))
      // console.log(flattenedEvents)
      // return attributes.map(o => {
      //   if (o.customData) {
      //     console.log(o.customData)
      //     return { key: o.key, startTime: moment(o.customData.startTime, 'HH:mm:ss').format('hh:mm a'), endTime: moment(o.customData.endTime, 'HH:mm:ss').format('hh:mm a') }
      //   }

      //   return { key: o.key, startTime: moment('00:00:00', 'HH:mm:ss').format('hh:mm a'), endTime: moment('23:59:59', 'HH:mm:ss').format('hh:mm a') }
      // })
    },
    dayClick (data) {
      console.log(data)
      this.$bus.$emit('modal:editEvents', data.attributes)
    },
    viewChange (change) {
      console.log('viewChange', change)
      const startAt = moment(change.startDate).startOf('month').format('YYYY-MM-DD')
      const endAt = moment(change.startDate).endOf('month').format('YYYY-MM-DD');

      this.getScheduleRoutingProfiles(this.$route.params.id, startAt, endAt)
    },
    pageChange (page) {
      const pageDate = moment(`${page.year}-${page.month}`, 'YYYY-M')
      const startAt = moment(pageDate).startOf('month').format('YYYY-MM-DD')
      const endAt = moment(pageDate).endOf('month').format('YYYY-MM-DD');

      this.getScheduleRoutingProfiles(this.$route.params.id, startAt, endAt)
    },
    async toggleNumber (numberId) {
      const id = this.$route.params.id
      const index = this.numbers.findIndex(o => o.id == numberId)
      if (index >= 0) {
        const number = this.numbers[index]
        if (number.scheduleId > 0) {
          number.scheduleId = null
        } else {
          number.scheduleId = id
        }
        await this.$axios.put(`/v1/numbers/${numberId}`, number)
        this.$store.dispatch('account/getNumbers')
        this.$store.dispatch('account/getSchedules')
      }
    },
    async save () {
      const id = this.$route.params.id

      const { data } = await this.$axios.put(`/v1/schedules/${id}`, this.schedule)
      await this.$store.dispatch('account/getSchedules')
      Object.assign(this.schedule, data)
      this.$snotify.success('Schedule Saved')
    },
    del () {

    },
    getSchedule (id) {
      const schedule = this.schedules.find(o => o.id == id)
      if (schedule) this.schedule = schedule
      this.$axios.get(`/v1/schedules/${id}`).then(({ data }) => {
        this.schedule = data
      })
    },
    getScheduleRoutingProfiles (id, startAt, endAt) {
      this.$axios.get(`/v1/schedules/profiles?scheduleId=${id}&startAt=${startAt}&endAt=${endAt}`).then(({ data }) => {
        this.scheduleRoutingProfiles = data
      })
    }
  },
  created () {
    this.getSchedule(this.$route.params.id)
  },
}
</script>

<style lang="scss">
a {
  &.bland {
    color: rgb(104, 107, 110);

    &:hover {
      text-decoration: none;
    }
  }
}
.vuecal__event {
  &.background {
    background: repeating-linear-gradient(45deg, transparent, transparent 10px, #f2f2f2 10px, #f2f2f2 20px);/* IE 10+ */
    color: #999;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
::-webkit-scrollbar {
  width: 0px;
}
::-webkit-scrollbar-track {
  display: none;
}
</style>

